import { FontAwesome5 } from '@expo/vector-icons';
import { OEButton, OEText, ph } from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import { format } from 'date-fns';
import { DataTable } from 'react-native-paper';

import { MessageItem } from '../../interfaces/message-notification';

interface MessageItemProps {
  item: MessageItem;
  onRemove: () => void;
}

export const MessageRow = ({ item, onRemove }: MessageItemProps) => {
  const messageTime = item.createdDate
    ? format(new Date(item.createdDate), 'EEEE, MMMM dd, yyyy HH:mm:ss a')
    : '';

  return (
    <DataTable.Row key={item.id} style={[ph(0)]}>
      <Cell flex={0.8}>{messageTime}</Cell>
      <Cell flex={0.5}>{item?.notifierName}</Cell>
      <Cell flex={1}>{item.notification}</Cell>
      <CellView flex={0.4}>
        <OEButton type="danger" onPress={onRemove}>
          <FontAwesome5 name="trash" />
        </OEButton>
      </CellView>
    </DataTable.Row>
  );
};

type FlexProps = {
  flex: number;
};

const Cell = styled(OEText)<FlexProps>`
  padding: 4px;
  flex: ${({ flex }) => flex};
  justify-content: flex-start;
  align-items: center;
  display: flex;
`;

const CellView = styled.View<FlexProps>`
  padding: 4px;
  align-items: flex-end;
  flex: ${({ flex }) => flex};
`;
